import React, { Component } from 'react'
import PropTypes from 'prop-types'
import CourseHeader, {
  scopeAndSequenceLinksType,
  lessonsAmountsType,
} from 'experienceComponents/CourseHeader'
import CourseInstanceCard from 'experienceComponents/CourseInstanceCard'
import LearnErrorBoundary from 'components/LearnErrorBoundary'
import { isFlagOn } from 'utils/featureFlags'
import { isK5Url } from 'utils/routing/routeHelpers'

export default class CourseComponent extends Component {
  static propTypes = {
    children: PropTypes.oneOfType([
      PropTypes.array,
      PropTypes.object,
      PropTypes.string,
    ]),
    createdDate: PropTypes.string,
    displayTitle: PropTypes.string,
    forwardedRef: PropTypes.oneOfType([
      PropTypes.func,
      PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
    ]),
    instance: PropTypes.string,
    isEditable: PropTypes.bool,
    lessonsAmounts: lessonsAmountsType,
    listView: PropTypes.bool,
    onBlur: PropTypes.func,
    onFocus: PropTypes.func,
    scoId: PropTypes.number,
    scopeAndSequenceLinks: scopeAndSequenceLinksType,
    selectCourseInstance: PropTypes.func,
    setFocus: PropTypes.func,
    skipHead: PropTypes.bool,
    title: PropTypes.string,
    totalAmount: PropTypes.number,
    totalComplete: PropTypes.number,
  }

  handleSelectCourseInstance = () => {
    const { props } = this
    if (!props.selectCourseInstance) return null
    return props.selectCourseInstance(props.instance)
  }

  parseGradeText = gradeText => {
    if (!gradeText) {
      return ''
    }

    const normalized = String(gradeText).trim()
    const lower = normalized.toLowerCase()

    if (lower === 'kindergarten' || lower === 'grade k') {
      return 'K'
    }

    const gradeMatch = normalized.match(/^Grade\s+(\d{1,2})$/i)
    if (gradeMatch?.[1]) {
      return gradeMatch[1]
    }

    return normalized.slice(6, 7)
  }

  onComponentDidMount() {
    if (isK5Url() && isFlagOn(['feature_LEARN-20164-k5-site-selection'])) {
      console.log('[DEBUG] CourseComponent rendering K5 in program flex')
    }
  }

  render() {
    const {
      children,
      createdDate,
      displayTitle,
      isEditable,
      listView,
      onBlur,
      onFocus,
      title,
      scoId,
      scopeAndSequenceLinks,
      setFocus,
      lessonsAmounts,
      totalAmount,
      totalComplete,
      instance,
      skipHead,
    } = this.props

    const gradeNumber = this.parseGradeText(displayTitle)

    return (
      <LearnErrorBoundary>
        {listView && (
          <CourseInstanceCard
            course={this.props}
            courseInstanceName={title}
            createdDate={createdDate}
            gradeNumber={gradeNumber}
            gradeTitle={title}
            isEditable={isEditable}
            key={`course-instance-${title}`}
            onBlur={onBlur}
            onFocus={onFocus}
            ref={this.props.forwardedRef}
            scoId={scoId}
            setFocus={setFocus}
            totalAmount={totalAmount}
            totalComplete={totalComplete}
            viewLessonsOnClick={this.handleSelectCourseInstance}
          />
        )}
        {!listView && (
          <CourseHeader
            dataTestId="course-instance-header"
            gradeNumber={gradeNumber}
            gradeTitle={title}
            isPreview={!instance}
            key={`course-instance-header-${title}`}
            lessonsAmounts={lessonsAmounts}
            scopeAndSequenceLinks={scopeAndSequenceLinks}
            skipHead={skipHead}
          />
        )}
        {children && children}
      </LearnErrorBoundary>
    )
  }
}
